import { useQuery } from "react-query";

import axios, { AxiosError } from "axios";

import { SYNC_SVC_ADDRESS } from "../../../constants/app.constants";

export interface UserSyncMetadata {
  schema: string;
  lastUpdated: Date;
}

const fetchSticksMetadata = async (schema: string): Promise<UserSyncMetadata> => {
  const response = await axios.get<UserSyncMetadata>(
    `${SYNC_SVC_ADDRESS}/api/stick-sync/${schema}/metadata`
  );

  return response.data;
};

export const useFetchSticksMetadata = (schema: string, enabled: boolean = true) => {
  return useQuery<UserSyncMetadata, AxiosError>(
    ["sticksMetadata", schema],
    () => fetchSticksMetadata(schema),
    {
      enabled: enabled && Boolean(schema),
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000 // 5 minutes
    }
  );
};
